import styled, { css } from "styled-components";
import { IThemeProps, themeTypes } from "../../../interfaces";
import { background, inactiveItens, shadowColor } from "../../../theme";

export const Form = styled.form`
    display: flex;
    flex-direction: column;
    gap:10px;
`

export const Anchor = styled.a<IThemeProps>`
    font-weight: 600;
    ${props => css`
        color: ${inactiveItens[props.theme as themeTypes]} !important;
    `}
`

export const Container = styled.div<IThemeProps>`
    display: flex;
    flex-direction: column;
    position: relative;
    border-radius: 0.3125rem;
    outline: 0;
    min-width:100vw;
    max-width:100vw;
    min-height: calc(100 * var(--vh));
    max-height: calc(100 * var(--vh));
    padding-bottom: 10px;
    @media (min-width: 1024px) {
        min-width: 550px;
        max-width: 1000px;
        min-height: 0px;
    }
    ${props => css`
        background: ${background[props.theme as themeTypes]};
        color: ${inactiveItens[props.theme as themeTypes]};
        box-shadow: 0.125rem 0.125rem 0.5rem ${shadowColor[props.theme as themeTypes]};
    `}
`

export const ContainerCrmLogo = styled.div`
    display: flex;
    position: relative;
    justify-content: center;
    gap: 10px;
    font-weight: 600;
    font-size: 22px;
`

export const ContentCountdown = styled.div`
    display: flex;
    justify-content: flex-end;
    padding-right: 20px;
    margin-top: -10px;
    @media (max-width: 1024px) and (min-width: 800px) {
        padding-right: 35px;
        margin-bottom: 240px;
    }
    @media (max-width: 800px) {
        justify-content: center;
        margin-top: 10px;
    }
`

export const Content = styled.div`
    display: flex;
    flex-direction: row;
    overflow: auto;
    padding: 20px;
    gap:40px;
    flex: 1;
    @media (max-width: 800px) {
        flex-direction: column;
    }
`

export const TextInformation = styled.div`
    background: #FFF3CD;
    border-radius: 5px;
    color: #856404;
    padding: 20px;
`

export const TextHeaderStep = styled.div`
    font-size: 22px;
    font-weight: 500;
    padding-bottom: 9px;
`

export const TextDescription = styled.div`
    font-size: 14px;
    padding-bottom: 24px;
`

export const ContainerTextStep = styled.div`
    font-size: 14px;
`

export const TextStep = styled.div`
    font-size: 14px;
    padding-bottom: 14px;
`

export const TextFooter = styled.div`
    padding-top: 18px;
    font-size: 10px;
    line-height: 1.2; 
`